var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { PartnerType } from "../types/PartnerType";
import { CooperationType } from "../types/CooperationType";
import { HealthCareDistrict } from "../types/HealthCareDistrict";
import { MeasurementMethod } from "../types/MeasurementMethod";
import { OperationType } from "../types/OperationType";
import { CollectionMethod } from "../types/CollectionMethod";
import { TargetGroup } from '../types/TargetGroup';
import { BAidType } from '@/common/types/BAidType';
import { MeasurementType } from '../types/MeasurementType';
import { ImpactType } from '../types/ImpactType';
import { ParticipationImpactType } from '../types/ParticipationImpactType';
import { NewOperationPermanenceType } from '../types/NewOperationPermanenceType';
import { OnlineOperationType } from '../types/OnlineOperationType';
export function enumKeys(obj) {
    return Object.keys(obj).filter(function (k) { return Number.isNaN(+k); });
}
/**
 * Constructs an options array from the members of given option type enum.
 * @param ctor Option constructor.
 * @param optionType Option type.
 * @param useKey Set to true, to use the literal value of the enum as its key. Set to false to use the enum value as its key.
 * @param localiser Localiser function used for transcribing enum options into localised values.
 * @param blacklist Exclude an enum value from an option array
 */
export function optionsFor(ctor, optionType, useKey, localiser, blacklist) {
    var e_1, _a;
    if (useKey === void 0) { useKey = false; }
    if (localiser === void 0) { localiser = function (path) { return path; }; }
    if (blacklist === void 0) { blacklist = []; }
    var array = [];
    var typeEnum = optionEnumFor(optionType);
    try {
        for (var _b = __values(enumKeys(typeEnum)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var type = _c.value;
            /* This hack omits the 0-value of the enum. It is assumed that 0-value indicates a 'null' placeholder, and that user should be not allowed to pick it. */
            if (!typeEnum[type])
                continue;
            if (blacklist.includes(typeEnum[type]))
                continue;
            var localisationPath = "Enums." + optionType + "." + (useKey ? String(type) : typeEnum[type]);
            var option = new ctor();
            option.id = typeEnum[type];
            option.name = localiser(localisationPath);
            array.push(option);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return array;
}
function optionEnumFor(optionType) {
    switch (optionType) {
        case "PartnerTypeOptions":
            return PartnerType;
        case "CooperationTypeOptions":
            return CooperationType;
        case "HealthCareDistrictOptions":
            return HealthCareDistrict;
        case "MeasurementMethodOptions":
            return MeasurementMethod;
        case "MeasurementTypeOptions":
            return MeasurementType;
        case "OperationTypeOptions":
            return OperationType;
        case "CollectionMethodOptions":
            return CollectionMethod;
        case "TargetGroup":
            return TargetGroup;
        case "BOptions":
            return BAidType;
        case "ImpactOptions":
            return ImpactType;
        case "ImpactOnParticipationOptions":
            return ParticipationImpactType;
        case "NewOperationPermanenceOptions":
            return NewOperationPermanenceType;
        case "OnlineOperationOptions":
            return OnlineOperationType;
        default:
            throw new Error("Unsupported optionType " + optionType + ".");
    }
}
